import React from "react";

import paperPlanIcon from "../../../assets/images/paper-plane.png";

import ModalHolder from "../../molecules/ModalHolder";

import { H3, P } from "../../atoms/Texts";
import { PrimaryButton } from "../../atoms/Buttons";

const CreateServiceSuccessModal = ({ closeModal, message }) => {
  return (
    <ModalHolder closeModal={closeModal}>
      <div className="py-20">
        <img src={paperPlanIcon} alt="" className="h-24 w-24 mx-auto mb-10" />
        <H3 color="#22202D" fontFamily="medium" className="text-center">
          Service {message ? message : "Published"}
        </H3>
        <P color="#7D7B96" className="text-center md:w-3/4 mx-auto mt-2 mb-6">
          Your service is now live
        </P>
        <div className="flex justify-center">
          <PrimaryButton.Light onClick={closeModal}>
            Back to Services Home
          </PrimaryButton.Light>
        </div>
      </div>
    </ModalHolder>
  );
};

export default CreateServiceSuccessModal;
